<template>
  <div class="pagination" layout layout-align="end-center">
    <div class="total">総件数 {{ formatNumber(total) }}</div>
    <div class="paging-size">
      表示件数 &nbsp;
      <el-select v-model="pagingSize" @change="changeLimitCount">
        <el-option v-for="item in pagingSizes" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </div>
    <el-pagination
      :current-page="currentPage"
      :total="total"
      :page-size="pagingSize"
      @current-change="changePagingNo"
      layout="prev, pager, next"
    ></el-pagination>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.pagination {
  width: 100%;
  line-height: 32px;

  .total {
    margin-right: $spacing-unit * 4;
  }

  .paging-size {
    margin-right: $spacing-unit * 4;
  }
}
</style>
<style lang="scss">
.pagination {
  .paging-size {
    .el-select .el-input--suffix .el-input__inner {
      width: 64px;
      height: 28px;
    }
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue'

import { formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'

export default defineComponent({
  props: {
    total: {
      type: Number,
      default: 0
    },
    limitCount: {
      type: Number,
      default: 25
    },
    pagingNo: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: ''
    },
    onChangeLimitCount: Function,
    onChangePagingNo: Function
  },
  data() {
    return {
      currentPage: this.pagingNo,
      pagingSize: this.limitCount,
      pagingSizes: [10, 25, 50]
    }
  },
  watch: {
    limitCount() {
      this.pagingSize = this.limitCount
    },
    pagingNo() {
      this.currentPage = this.pagingNo
    }
  },
  methods: {
    formatNumber,

    changeLimitCount(value: number) {
      switch (this.type) {
        case 'twitter':
          TrackingService.sendEvent(`select:応募グループ一覧（X）|表示件数`)
          break
        case 'instagram':
          TrackingService.sendEvent(`select:応募グループ一覧（IG）|表示件数`)
          break
        case 'テンプレート':
          TrackingService.sendEvent(`select:グループ設定|テンプレート|表示件数`)
          break
        case 'NGアカウント':
          TrackingService.sendEvent(`select:グループ設定|NGアカウント|表示件数`)
          break
        case '利用実績':
          TrackingService.sendEvent(`select:グループ設定|利用実績|表示件数`)
          break
        case '応募履歴（X）':
          TrackingService.sendEvent(`select:応募履歴（X）|表示件数`)
          break
        case '応募履歴（IG）':
          TrackingService.sendEvent(`select:応募履歴（IG）|表示件数`)
          break
        case 'シルアルコード管理':
          TrackingService.sendEvent(`select:当選メッセージの管理|シルアルコード管理|表示件数`)
          break
        case '応募一覧（X）':
          TrackingService.sendEvent(`select:応募一覧（X）|表示件数`)
          break
        case '応募一覧（IG）':
          TrackingService.sendEvent(`select:応募一覧（IG）|表示件数`)
          break
        case '当落ページ管理（X）':
          TrackingService.sendEvent(`select:応募一覧（IG）|表示件数`)
          break
        default:
          break
      }

      // 表示件数変更時は現在ページを1にリセットし、pagingSizeを更新
      this.currentPage = 1
      this.pagingSize = value

      if (typeof this.onChangeLimitCount === 'function') {
        this.onChangeLimitCount(value)
      }

      this.$emit('paging', { pagingNo: 1, limitCount: value })
    },

    changePagingNo(page: number) {
      let actionPaging

      if (page === this.pagingNo + 1) {
        actionPaging = '|次へ'
      } else if (page === this.pagingNo - 1) {
        actionPaging = '|前へ'
      } else actionPaging = ''

      switch (this.type) {
        case 'twitter':
          TrackingService.sendEvent(`select:応募グループ一覧（X）|ページネーション${actionPaging}`)
          break
        case 'instagram':
          TrackingService.sendEvent(`select:応募グループ一覧（IG）|ページネーション${actionPaging}`)
          break
        case 'テンプレート':
          TrackingService.sendEvent(`select:グループ設定|テンプレート|ページネーション${actionPaging}`)
          break
        case 'NGアカウント':
          TrackingService.sendEvent(`click:グループ設定|NGアカウント|ページネーション${actionPaging}`)
          break
        case '利用実績':
          TrackingService.sendEvent(`click:グループ設定|利用実績|ページネーション${actionPaging}`)
          break
        case '応募履歴（X）':
          TrackingService.sendEvent(`click:応募履歴（X）|ページネーション${actionPaging}`)
          break
        case '応募履歴（IG）':
          TrackingService.sendEvent(`click:応募履歴（IG）|ページネーション${actionPaging}`)
          break
        case 'シルアルコード管理':
          TrackingService.sendEvent(`click:当選メッセージの管理|シルアルコード管理|ページネーション${actionPaging}`)
          break
        case '応募一覧（X）':
          TrackingService.sendEvent(`click:応募一覧（X）|ページネーション${actionPaging}`)
          break
        case '応募一覧（IG）':
          TrackingService.sendEvent(`click:応募一覧（IG）|ページネーション${actionPaging}`)
          break
        case '当落ページ管理（X）':
          TrackingService.sendEvent(`click:当落ページ管理（X）|ページネーション${actionPaging}`)
          break
        default:
          break
      }

      // currentPageを更新
      this.currentPage = page

      if (typeof this.onChangePagingNo === 'function') {
        this.onChangePagingNo(page)
      }

      this.$emit('paging', { pagingNo: page })
    }
  }
})
</script>
